// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

/**
 * Foods catalog — vet-managed feed inventory used by AdapetApp's manual
 * feed-log sheet (the "what food is this?" picker) and the kcal_in side
 * of the calorie-balance card.
 *
 * Vets with role admin/super_admin/vet/cms can list, create, edit, and
 * soft-delete foods.  Server-side access controls live in
 * `ada-core/src/collections/Foods/index.ts`.
 */

import {
  BooleanField,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  NumberField,
  SearchInput,
  SelectInput,
  TextField,
  TextInput,
  useTranslate,
} from 'react-admin'

const FoodList = () => {
  const translate = useTranslate()
  const foodFilters = [
    <SearchInput key="q" source="q" alwaysOn />,
    <SelectInput
      key="species"
      source="species"
      choices={[
        { id: 'dog', name: translate('resources.foods.species.dog') },
        { id: 'cat', name: translate('resources.foods.species.cat') },
        { id: 'both', name: translate('resources.foods.species.both') },
      ]}
    />,
    <TextInput key="brand" source="brand" />,
  ]
  return (
    <List
      filters={foodFilters}
      sort={{ field: 'brand', order: 'ASC' }}
      perPage={25}
      filter={{ active: true }}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="brand" label={translate('resources.foods.fields.brand')} />
        <TextField source="productName" label={translate('resources.foods.fields.productName')} />
        <FunctionField
          label={translate('resources.foods.fields.species')}
          render={(rec: any) =>
            rec?.species === 'both'
              ? translate('resources.foods.species.dog_and_cat')
              : rec?.species === 'dog'
                ? translate('resources.foods.species.dog')
                : translate('resources.foods.species.cat')
          }
        />
        <NumberField
          source="kcalPerGram"
          label={translate('resources.foods.fields.kcalPerGram')}
          options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
        />
        <NumberField source="proteinPercent" label={translate('resources.foods.fields.protein')} />
        <NumberField
          source="carbohydratePercent"
          label={translate('resources.foods.fields.carb')}
        />
        <NumberField source="glycemicIndex" label={translate('resources.foods.fields.gi')} />
        <BooleanField
          source="diabeticFriendly"
          label={translate('resources.foods.fields.diabeticFriendly')}
        />
        <EditButton />
      </Datagrid>
    </List>
  )
}

export default FoodList
